export default __webpack_public_path__ + "static/media/link-green.1b9d0561.svg";